module.exports = __webpack_public_path__ + "img/redvblue.326f5350.png";